import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { SchedulingAlarmComponent } from './scheduling-alarm.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'ma-form-field-alarm',
    template: ` <ma-scheduling-alarm [formControl]="formControl"></ma-scheduling-alarm> `,
    imports: [SchedulingAlarmComponent, FormsModule, ReactiveFormsModule]
})
export class AlarmFormFieldComponent extends FieldType {}
